import axios from 'axios';
import { LOAD_API_DATA, SET_API_DATA, SET_FORM_OPTION } from './home.type';
import { SET_API_DATA as SET_API_DATA_DATAASSETS, LOAD_API_DATA as LOAD_API_DATAASSET } from "../dataAssets/dataAssets.type"
import axiosInstance from '../../axiosInstanceSetup';
import { getdataAssets } from '../dataAssets/dataAssets.action';
import { rundataAssetProfiler } from '../dataAsset/dataAsset.action';
import { SET_NOTIFICATION_ARRAY } from '../crumbs/crumbs.type';

export const getHomedataAssets = () => {
  return async (dispatch, getState, { endpoint }) => {
    dispatch({
      type: LOAD_API_DATA,
      payload: { apiField: "dataAssests" },
    });

    axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_ASSETS}`)
      .then(response => {
        // Handle success
        if (response.data.status === "success") {
          dispatch({
            type: SET_API_DATA,
            payload: {
              apiField: "dataAssests",
              data: response.data.data,
              status: "success",
            },
          })
        }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
  };
};

export const getdataProducts = () => {
  return async (dispatch, getState, { endpoint }) => {
    dispatch({
      type: LOAD_API_DATA,
      payload: { apiField: "dataProducts" },
    });
    axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_PRODUCTS}`)
      .then(response => {
        // Handle success
        if (response.data.status === "success") {
          dispatch({
            type: SET_API_DATA,
            payload: {
              apiField: "dataProducts",
              data: response.data.data,
              status: "success",
            },
          })
          dispatch({
            type: SET_FORM_OPTION,
            payload: {
              formField: "productName",
              data: response.data.data
            }
          })
        }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
  };
};

export const getDataDomainSubdomain = () => {
  return async (dispatch, getState, { endpoint }) => {
    dispatch({
      type: LOAD_API_DATA,
      payload: { apiField: "domainSubDomain" },
    });
    axiosInstance.get(`${endpoint}${process.env.REACT_APP_DOMAIN_SUBDOMAIN}`)
      .then(response => {
        // Handle success
        if (response.data.status === "success") {
          dispatch({
            type: SET_API_DATA,
            payload: {
              apiField: "domainSubDomain",
              data: response.data.data,
              status: "success",
            },
          })
          dispatch({
            type: SET_FORM_OPTION,
            payload: {
              formField: "domainSubDomainForm",
              data: response.data.data
            }
          })
        }
        // let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
        // tempArray.push("fetched Domain SubDomain successfully")
        // sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
  };
};
export const getRegion = () => {
  return async (dispatch, getState, { endpoint }) => {
    dispatch({
      type: LOAD_API_DATA,
      payload: { apiField: "regionCountry" },
    });
    axiosInstance.get(`${endpoint}${process.env.REACT_APP_REGION_COUNTRY}`)
      .then(response => {
        // Handle success
        if (response.data.status === "success") {
          dispatch({
            type: SET_API_DATA,
            payload: {
              apiField: "regionCountry",
              data: response.data.data,
              status: "success",
            },
          })
          let updatedRegion = []

          response.data.data.map((val) => {
            let match = 0
            if (updatedRegion.length === 0) {
              updatedRegion.push({ region: val.region, country: [] })
            } else {
              updatedRegion.map((val1) => {
                if (val.region === val1.region) {
                  match = 1
                }
              })
              if (match === 0) {
                updatedRegion.push({ region: val.region, country: [] })
              }
            }
          })
          updatedRegion.map((val1) => {
            response.data.data.map((val) => {
              if (val.region === val1.region) {
                val1.country.push(val.country)
              }
            })
          })
          console.log("updated region")
          console.log(updatedRegion)
          dispatch({
            type: SET_FORM_OPTION,
            payload: {
              formField: "region",
              data: updatedRegion
            }
          })
        }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
  };
};
export const getAssetOwner = () => {
  return async (dispatch, getState, { endpoint }) => {

    axiosInstance.get(`${endpoint}${process.env.REACT_APP_ASSET_OWNER}`)
      .then(response => {
        // Handle success
        // if (response.data.status === "success") {
        dispatch({
          type: SET_FORM_OPTION,
          payload: {
            formField: "dataAssetOwner",
            data: response.data.data_owners
          }
        })
        dispatch({
          type: SET_FORM_OPTION,
          payload: {
            formField: "dataSteward",
            data: response.data.data_stewards
          }
        })
        // }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
  };
};
export const getADLSAccount = () => {
  return async (dispatch, getState, { endpoint }) => {

    axiosInstance.get(`${endpoint}${process.env.REACT_APP_ADLS_ACCOUNT}`)
      .then(response => {
        // Handle success
        // if (response.data.status === "success") {
        dispatch({
          type: SET_FORM_OPTION,
          payload: {
            formField: "adlsList",
            data: response.data.adls_accounts
          }
        })
        // }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
  };
};
export const getADLSFile = (account_name) => {
  return async (dispatch, getState, { endpoint }) => {
    dispatch({
      type: LOAD_API_DATA,
      payload: { apiField: "adlsDirectory" },
    });
    axiosInstance.get(`${endpoint}${process.env.REACT_APP_ADLS_FILE}?account_name=${account_name}`)
      .then(response => {
        // Handle success
        // if (response.data.status === "success") {
        dispatch({
          type: SET_API_DATA,
          payload: {
            apiField: "adlsDirectory",
            data: response.data,
            status: "success",
          },
        })
        let adlsFile = []
        Object.keys(response.data.adls_files).map((val) => {
          if (val !== "sample_file/1FB774F0-C8D7-481E-96F7-D13ED46D3895") {
            adlsFile.push({ name: val })
          }


        })
        dispatch({
          type: SET_FORM_OPTION,
          payload: {
            formField: "adlsDirectoryForm",
            data: adlsFile
          }
        })
        // }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
  };
};
export const addNewDataAsset = (show, showLoadingMessage) => {
  return async (dispatch, getState, { endpoint }) => {
    const { home: { formData, apiData } } = getState();
    dispatch({
      type: LOAD_API_DATAASSET,
      payload: { apiField: "newDataAssest" },
    });
    let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
    tempArray.push("The onboarding process may take up to 1-2 min.Please be patient while the newly asset become visible on the page.")
    sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
    dispatch({
      type:SET_NOTIFICATION_ARRAY,
      payload:{
          value:tempArray
      }
  })
    dispatch({
      type: SET_NOTIFICATION_ARRAY,
      payload: {
        value: tempArray
      }
    })
    showLoadingMessage()
    const APIformData = new FormData();
    APIformData.append('data_prod_name', formData.productName.value);
    APIformData.append('data_asset_name', formData.assestName.value);
    APIformData.append('description', formData.assestDescription.value);
    APIformData.append('country', formData.country.value);
    APIformData.append('region', formData.region.valueAsObj.region);
    APIformData.append('domain', formData.domain.valueAsObj.domain_name);
    APIformData.append('sub_domain', formData.subDomain.valueAsObj.sub_domain_name);
    APIformData.append('created_date', JSON.stringify(new Date()));
    APIformData.append('created_by', localStorage.getItem("userId"));
    APIformData.append('last_modified_by', localStorage.getItem("userId"));
    APIformData.append('frequency', formData.frequency.value);
    APIformData.append('data_steward', formData.dataSteward.value);
    APIformData.append('data_asset_owner', formData.dataAssetOwner.value);
    APIformData.append("is_active", true)
    if (formData.filePickUp.value === "Local") {
      APIformData.append('file', formData.selectedFile.value);
    } else if (formData.filePickUp.value === "ADLS") {
      APIformData.append('file_path', `${apiData.adlsDirectory.data.adls_directory_path}/${formData.adlsDirectoryForm.value}/${formData.adlsFileName.value}`);
      APIformData.append('adls_account_name', formData.adlsList.value);

    }
    // APIformData.append('file', formData.filePickUp.value!=="Local"?undefined:formData.selectedFile.value);
    // APIformData.append('file_path',  formData.filePickUp.value!=="ADLS"?undefined:`${formData.adlsDirectoryForm.value}/${formData.adlsFileName.value}`);
    // APIformData.append('adls_account_name', formData.filePickUp.value!=="ADLS"?undefined:formData.adlsList.value);
    // formData.append('file', fileInput.files[0]);
    axiosInstance.post(`${endpoint}${process.env.REACT_APP_GET_ASSETS}`, APIformData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        // Add any other custom headers as needed
      },


    })
      .then(response => {
        // Handle success
        if (response.data.status === "success") {
          dispatch({
            type: SET_API_DATA_DATAASSETS,
            payload: {
              apiField: "newDataAssest",
              data: response.data.data,
              status: "success",
            },
          })
          dispatch(rundataAssetProfiler(response.data.data.asset.data_asset_id))
          dispatch(getdataAssets())
          show(response.data.status, response.data.message)
          let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
          tempArray.push(response.data.message)
          sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
          dispatch({
            type:SET_NOTIFICATION_ARRAY,
            payload:{
                value:tempArray
            }
        })
        }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
  };
};